import ReactECharts from "echarts-for-react";

export default function HoriBarChart({ data, heading, top, height }) {
  const totalItems = data?.valData?.length;
  const visibleItems = 5;
  const options = {
    title: {
      text: heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 18,
        fontWeight: "600",
      },
    },

    grid: {
      left: "2%",
      right: "4%",
      bottom: "3%",
      top: top,
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    xAxis: {
      show: false,
      type: "value",
      splitLine: {
        show: false,
      },
    },

    yAxis: {
      type: "category",
      data: data.keyData,
      axisLabel: {
        fontSize: 12,
      },
      axisTick: {
        show: false,
      },
    },
    series: [
      {
        data: data.valData,
        type: "bar",
        barWidth: 20,
        barMinHeight: 30,
        itemStyle: {
          color: "#EF6AE9",
          borderRadius: [0, 10, 10, 0],
        },

        label: {
          show: true,
          position: "inside",
          formatter: "{c}",
          color: "#fff",
          fontSize: 15,
        },
      },
    ],
    ...(totalItems > 5 && {
      dataZoom: [
        {
          type: "slider",
          yAxisIndex: 0,
          start: 100 - (visibleItems / totalItems) * 100,
          end: 100,
          orient: "vertical",
          handleSize: 5,
          width: 10,
          showDetail: false,
          fillerColor: "#2A5775",
          backgroundColor: "#ccc",
          handleColor: "#2A5775",
          zoomOnMouseWheel: false,
          moveOnMouseMove: false,
          moveOnMouseWheel: false,
          right: 2,
          zoomLock: true,
        },
      ],
    }),
  };

  return (
    <ReactECharts option={options} style={{ height: height, width: "100%" }} />
  );
}
